import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-value-switcher',
  templateUrl: './value-switcher.component.html',
  styleUrls: ['./value-switcher.component.scss'],
})
export class ValueSwitcherComponent implements OnInit {
  @Input()
  title = ''

  @Input()
  disabled = false

  @Input()
  labelOne = ''

  @Input()
  labelTwo = ''

  @Input()
  valueOne: any = ''

  @Input()
  valueTwo: any = ''

  @Input()
  value

  @Output()
  changes = new EventEmitter<any>()

  private _id = ''

  ngOnInit() {
    this._id = this.title.replace(/ /g, '') + (Math.random() * 10000).toFixed(0)
  }

  get id(): string {
    return this._id
  }

  toggle() {
    this.value = this.value === this.valueOne ? this.valueTwo : this.valueOne
    this.changes.emit({ value: this.value })
  }

  isChecked() {
    return this.value === this.valueOne
  }
}
